const COOKIE_PREFIX = 'ysh_';
const DEFAULT_MAX_AGE_SEC = 60 * 60 * 24 * 30; // 30 dni

function buildCookieString(name, value, maxAgeSec) {
  const parts = [
    `${COOKIE_PREFIX}${name}=${encodeURIComponent(value)}`,
    'Path=/',
    `Max-Age=${Math.max(0, Math.floor(maxAgeSec))}`,
    'SameSite=Lax',
  ];
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    parts.push('Secure');
  }
  return parts.join('; ');
}

export function setAuthCookie(name, value, maxAgeSec = DEFAULT_MAX_AGE_SEC) {
  if (typeof document === 'undefined') return false;
  try {
    document.cookie = buildCookieString(name, value, maxAgeSec);
    return getAuthCookie(name) === value;
  } catch {
    return false;
  }
}

export function getAuthCookie(name) {
  if (typeof document === 'undefined') return '';
  const prefix = `${COOKIE_PREFIX}${name}=`;
  const cookies = document.cookie.split(';');
  for (const raw of cookies) {
    const cookie = raw.trim();
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.slice(prefix.length));
    }
  }
  return '';
}

export function deleteAuthCookie(name) {
  if (typeof document === 'undefined') return;
  document.cookie = buildCookieString(name, '', 0);
}

export const AUTH_COOKIE_KEYS = {
  accessToken: 'at',
  refreshToken: 'rt',
  tokenType: 'tt',
  tokenExpiresAt: 'exp',
  username: 'un',
  email: 'em',
};

export function clearAllAuthCookies() {
  Object.values(AUTH_COOKIE_KEYS).forEach(deleteAuthCookie);
}

export function getAuthCookieMaxAge(expiresInSec) {
  const parsed = Number(expiresInSec);
  if (Number.isFinite(parsed) && parsed > 0) {
    return Math.max(parsed, 60 * 60 * 24);
  }
  return DEFAULT_MAX_AGE_SEC;
}
